<template>
    <div class="header-container">
        <div class="logo-box">
            <span class="wan-chao">苍穹云</span>
            <span class="system-txt">后台管理系统</span>
        </div>
        <div class="operation-box">
            <div class="clear" @click="clearCacheData()">
                <i class="el-icon-refresh"></i>
                <span>清除缓存</span>
            </div>
            <div class="recycle">
                <i class="icon iconfont icon-huishouzhan"></i>
                <span>回收站</span>
            </div>
            <div class="setting">
                <i class="icon iconfont icon-shezhi"></i>
                <span>设置</span>
            </div>
            <div class="user">
                <span>{{nickName}}</span>
            </div>
            <div class="logout" @click="logOut()" title="退出登录">
                <i class="icon iconfont icon-tuichu"></i>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeaderComponent',
    data() {
        return {
            nickName: '',
        }
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        getUserInfo() {
            if(window.sessionStorage.getItem('userInfo')) {
                let data = JSON.parse(window.sessionStorage.getItem('userInfo'));
                this.nickName = data.username;
            }
        },
        /**
         * @function clearCacheData 清除缓存数据
         */
        clearCacheData() {
            this.$axios.get(this.$urls.clearCache).then(res => {
                this.$cm.notificationShow('温馨提示', res.message, 185);
            });
        },
        logOut() {
            this.$axios.get(this.$urls.logout).then(res => {
                window.sessionStorage.clear();
                window.localStorage.clear();
                this.$router.push({name: 'Login'});
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import './HeaderComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/common/header/HeaderComponent.vue